<script>
  export let referenceElement;
  export let visible;
  export let content;

  import Popper from "@popperjs/svelte";

  // super-simple CSS Object to string serializer
  const css = (obj) =>
    Object.entries(obj || {})
      .map((x) => x.join(":"))
      .join(";");

  // DOM references to the interested elements
  //   let referenceElement;
  let popperElement;
  let arrowElement;

  // Popper options, reactive to update when arrowElement is set
  $: popperOptions = {
    modifiers: [
      { name: "offset", options: { offset: [0, 5] } },
      { name: "arrow", options: { element: arrowElement } },
    ],
  };

  // bound variables where Popper will store styles and attributes
  let styles = {};
  let attributes = {};
</script>

<Popper
  reference={referenceElement}
  popper={popperElement}
  options={popperOptions}
  bind:styles
  bind:attributes
>
  <slot />
  <div
    bind:this={popperElement}
    class="tooltip {visible ? 'visible' : ''}"
    style={css(styles.popper)}
    {...attributes.popper}
  >
    {content}
    <div bind:this={arrowElement} class="arrow" style={css(styles.arrow)} />
  </div>
</Popper>

<style>
  .title,
  .subtitle {
    display: block;
  }

  .tooltip {
    background: #333;
    color: white;
    font-weight: lighter;
    padding: 4px 8px;
    font-size: 13px;
    border-radius: 4px;
    z-index: 10;
    opacity: 0;
    transition: opacity 300ms ease;
    position: relative;
  }

  .visible {
    opacity: 1;
  }

  .arrow,
  .arrow::before {
    position: absolute;
    width: 8px;
    height: 8px;
    z-index: -1;
  }

  .arrow::before {
    content: "";
    transform: rotate(45deg);
    background: #333;
  }

  :global(.tooltip[data-popper-placement^="bottom"] > .arrow) {
    top: -4px;
  }

  :global(.tooltip[data-popper-placement^="top"] > .arrow) {
    bottom: -4px;
  }

  :global(.tooltip[data-popper-placement^="left"] > .arrow) {
    right: -4px;
  }

  :global(.tooltip[data-popper-placement^="right"] > .arrow) {
    left: -4px;
  }

  @media screen and (max-width: 767px) {
    .tooltip {
      opacity: 0 !important;
      visibility: hidden;
    }
  }

  :global(.modal .tooltip) {
    visibility: hidden;
  }
</style>
